import queryString from 'query-string';
import { get, post, del } from './apiUtils';

const defaultUrl = '/PhraseTranslations/';

export default {
  getPhraseTranslationList: query => (query ? get(`${defaultUrl}?${queryString.stringify(query)}`) : get(defaultUrl)),
  savePhraseTranslation: data => post(defaultUrl, data),
  // copyProductPhrasesFromProduct: ({ cpsrTypeCode, ...data }) =>
  //   post(`${defaultUrl}Copy?CpsrType=${cpsrTypeCode}`, data),
  // deleteProductPhrase: ids => del(defaultUrl, ids),
};
